import PostedFrequencyType from "@/models/Shared/PostedFrequencyType";

export default (postedFrequencyType: PostedFrequencyType) => {
    let returnVal = "Undefined";
    switch (postedFrequencyType) {
        case PostedFrequencyType.Disbursement:
            returnVal = "Disbursement"
            break;
        case PostedFrequencyType.Repayment:
            returnVal = "Repayment"
            break;
    }
    return returnVal;
}